





















































































import Vue from 'vue';
import Page from '@/components/Page.vue';
import Card from '@/components/common/Card.vue';
import FormInput from '@/components/common/form/FormInput.vue';
import InputText from '@/components/common/form/InputText.vue';
import Errors from '@/components/common/form/Errors.vue';
import CTAButton from '@/components/common/buttons/CTAButton.vue';
import SuccessIcon from '../components/common/icons/SuccessIcon.vue';
import { createNamespacedHelpers, mapState as mapRootState } from 'vuex';
const { mapState, mapActions, mapMutations, mapGetters } = createNamespacedHelpers('forgotPassword');
const mapCustomLabelsState = createNamespacedHelpers('customLabels').mapState;
export default Vue.extend({
    components: { Page, FormInput, InputText, Errors, CTAButton, Card, SuccessIcon },
    data: () => ({
        siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
    }),
    computed: {
        ...mapCustomLabelsState([
            'forgotPasswordGrievanceText',
            'portalTitle',
            'instanceTitle',
            'grievanceRefNo',
            'grievanceRefNoFormat',
            'grievanceNumberPlaceholder',
        ]),
        ...mapRootState(['locale']),
        ...mapState(['refNo', 'email', 'submitted', 'isSending']),
        ...mapGetters(['getFieldErrors']),
    },
    created() {
        const portalTitle = this.portalTitle;
        const instanceTitle = this.instanceTitle;
        document.title = `${instanceTitle} | ${this.$t('htmlTitle', { instanceTitle, portalTitle }) as string}`;
        this.$recaptchaInstance?.showBadge();
    },
    mounted() {
        this.resetForm();
        if (this.$route.query.refNo) {
            this.setRefNo({ refNo: this.$route.query.refNo });
        }
    },
    destroyed() {
        this.$recaptchaInstance?.hideBadge();
    },
    methods: {
        ...mapMutations(['setRefNo', 'setEmail', 'setRecaptchaVerifyId', 'resetForm']),
        ...mapActions(['forgotPassword']),
        async submit() {
            if (this.$data.siteKey) {
                await this.$recaptchaLoaded();
                const token = await this.$recaptcha('submit');
                this.setRecaptchaVerifyId({ recaptchaVerifyId: token });
            }

            await this.forgotPassword();
        },
    },
});
